export const ON_CHANGE_INFORMATION = 'ON_CHANGE_INFORMATION'
export const ON_CHANGE_ITEM = 'ON_CHANGE_ITEM'
export const CHECKED_ALL_ITEMS = 'CHECKED_ALL_ITEMS'
export const ON_CHANGE_CLASSES = 'ON_CHANGE_CLASSES'
export const ADD_ORDER = 'ADD_ORDER'
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS'
export const ADD_ORDER_FAILS = 'ADD_ORDER_FAILS'
export const ON_CHANGE_ADD_ORDER = 'ON_CHANGE_ADD_ORDER'
export const SEARCH_ITEM_CODE = 'SEARCH_ITEM_CODE'
export const CHECK_POSTAL_CODE = 'CHECK_POSTAL_CODE'
export const CHECK_POSTAL_CODE_SUCCESS = 'CHECK_POSTAL_CODE_SUCCESS'
export const CHECK_POSTAL_CODE_FAILS = 'CHECK_POSTAL_CODE_FAILS'
export const STATE_INFORMATION_DEFAULT = 'STATE_INFORMATION_DEFAULT'
export const STATE_INFORMATION_CLASSES_DEFAULT = 'STATE_INFORMATION_CLASSES_DEFAULT'
export const CONVERT_NAME = 'CONVERT_NAME'
export const CONVERT_NAME_SUCCESS = 'CONVERT_NAME_SUCCESS'
export const CONVERT_NAME_FAILS = 'CONVERT_NAME_FAILS'

export function onChangeInformation(payload) {
    return {
        type: ON_CHANGE_INFORMATION,
        payload,
    }
}

export function onChangeItem(payload) {
    return {
        type: ON_CHANGE_ITEM,
        payload,
    }
}

export function checkedAllItems(payload) {
    return {
        type: CHECKED_ALL_ITEMS,
        payload,
    }
}

export function onChangeClasses(payload) {
    return {
        type: ON_CHANGE_CLASSES,
        payload,
    }
}

export function addOrder(payload) {
    return {
        type: ADD_ORDER,
        payload,
    }
}

export function addOrderSuccess(payload) {
    return {
        type: ADD_ORDER_SUCCESS,
        payload,
    }
}

export function addOrderFails(payload) {
    return {
        type: ADD_ORDER_FAILS,
        payload,
    }
}

export function onChange(payload) {
    return {
        type: ON_CHANGE_ADD_ORDER,
        payload,
    }
}

export function searchItemCode(payload) {
    return {
        type: SEARCH_ITEM_CODE,
        payload: payload,
    }
}

export function checkPostalCode(payload) {
    return {
        type: CHECK_POSTAL_CODE,
        payload: payload,
    }
}

export function checkPostalCodeFails(payload) {
    return {
        type: CHECK_POSTAL_CODE_FAILS,
        payload: payload,
    }
}

export function checkPostalCodeSuccess(payload) {
    return {
        type: CHECK_POSTAL_CODE_SUCCESS,
        payload: payload,
    }
}

export function stateInformationDefault(payload) {
    return {
        type: STATE_INFORMATION_DEFAULT,
        payload: payload,
    }
}

export function stateInformationClassesDefault(payload) {
    return {
        type: STATE_INFORMATION_CLASSES_DEFAULT,
        payload: payload,
    }
}

export function convertName(payload) {
    return {
        type: CONVERT_NAME,
        payload: payload,
    }
}

export function convertNameSuccess(payload) {
    return {
        type: CONVERT_NAME_SUCCESS,
        payload: payload,
    }
}

export function convertNameFails(payload) {
    return {
        type: CONVERT_NAME_FAILS,
        payload: payload,
    }
}




// WEBPACK FOOTER //
// ./src/actions/addOrder.js